import { BrowserRouter } from 'react-router-dom';
import { Router } from './Router';
import { ErrorBoundary } from './providers/ErrorBoundary';
import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { ScrollToTop } from '@/components/shared/ScrollToTop';
import { CookieConsent } from '@/components/shared/CookieConsent';

/**
 * App shell — BrowserRouter + global chrome.
 * Navbar / Footer / scroll reset / WhatsApp CTA / cookie banner live here
 * so route transitions don't remount them. Error boundary wraps the route
 * tree so a single page crash doesn't blank the entire site.
 */
export default function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:rounded focus:bg-brand-yellow focus:px-4 focus:py-2 focus:text-brand-purple"
      >
        Pular para o conteúdo
      </a>
      <Navbar />
      <ErrorBoundary>
        <Router />
      </ErrorBoundary>
      <Footer />
      {/* <WhatsAppFloat /> */}
      <CookieConsent />
    </BrowserRouter>
  );
}
